class restoreContact {
    constructor(Alert, $http, $state, $translate) {

        this.key = 'restore-contact';
        this.title = 'Restore';
        this.level = 'archived-highlight';
        this.icon = 'fal fa-undo';
        this.alert = Alert;
        this.api = $http;
        this.state = $state;
        this.translate = $translate;
    }

    action(contact, vm) {
        const translatedValue = (path, params) => {
            return this.translate.instant(`contacts.workflows.ask-to-restore-contact.${path}`, params);
        };

        this.alert.animatedAlert(
            translatedValue('title'),
            translatedValue('content', {contact_name: contact.full_name}),
            'attention',
            {
                confirmButtonText: translatedValue('confirm'),
                cancelButtonText: translatedValue('cancel'),
                wait: true
            }).then(() => {
            return this.api.put(`contacts/${ contact.id }/restore`)
                .then(() => {
                    this.state.reload();
                    if (vm.store) {
                        return vm.store.dispatch('getData');
                    }
                }, err => this.alert.handle(err));
        }, () => ({}))
    }

}

angular
    .module('festzelt-os.contacts')
    .factory('restoreContact', [
        'Alert',
        '$http',
        '$state',
        '$translate',
        (Alert, $http, $state, $translate) => new restoreContact(Alert, $http, $state, $translate)
    ]);




// WEBPACK FOOTER //
// ./src/app/pages/contacts/workflows/detailed-view/restore-contact.js